import { GamgeeChatMessageRead } from "~/types/message";
import MarkdownContainer from "~/components/markdown-container/markdown-container";
import styles from './tool-section.module.css'; // Import the CSS module
import { useState } from 'react'; // Import useState for managing collapse state
import { FiChevronUp, FiChevronDown } from 'react-icons/fi'; // Import icons

const ToolSection = (
  { toolTitle, content, loading, message }: {
    toolTitle: string,
    content: string,
    loading: boolean,
    message: GamgeeChatMessageRead
  }
) => {
  const [isCollapsed, setIsCollapsed] = useState(true); // State to manage collapse

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`${styles.toolSection} ${isCollapsed ? styles.collapsed : ''}`}>
      <div 
        className={`${styles.toolTitle} ${loading ? styles.loading : ''}`}
        onClick={toggleCollapse}
      >
        <span>
          {toolTitle}
        </span>
        <span className={styles.arrow}>
          {isCollapsed ? <FiChevronDown /> : <FiChevronUp />} 
        </span>
      </div>
      {!isCollapsed && (
        <div className={styles.toolContent}>
          <MarkdownContainer message={message}>
            {content}
          </MarkdownContainer>
        </div>
      )}
    </div>
  );
};

export default ToolSection;
